"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

export const createToolRegistry = {
  getPageLocks: {
    kind: "step",
    category: "create",
    view: lazy(() =>
      import("./get-page-locks").then(({ GetPageLocksToolView }) => ({
        default: GetPageLocksToolView,
      }))
    ),
  },
  exportDesign: {
    kind: "step",
    category: "create",
    view: lazy(() =>
      import("./export-design").then(({ ExportDesignToolView }) => ({
        default: ExportDesignToolView,
      }))
    ),
  },
  exportPdf: {
    kind: "step",
    category: "create",
    view: lazy(() =>
      import("./export-pdf").then(({ ExportPdfToolView }) => ({
        default: ExportPdfToolView,
      }))
    ),
  },
  versionHistory: {
    kind: "step",
    category: "create",
    view: lazy(() =>
      import("./version-history").then(({ VersionHistoryToolView }) => ({
        default: VersionHistoryToolView,
      }))
    ),
  },
  saveVersion: {
    kind: "step",
    category: "create",
    view: lazy(() =>
      import("./save-version").then(({ SaveVersionToolView }) => ({
        default: SaveVersionToolView,
      }))
    ),
  },
  // Pilot transcripts persist the old tool name in their message parts, and
  // an unmatched key falls back to the generic card. The server only ever
  // emits `saveVersion`; drop this once those chats age out.
  publishVersion: {
    kind: "step",
    category: "create",
    view: lazy(() =>
      import("./save-version").then(({ SaveVersionToolView }) => ({
        default: SaveVersionToolView,
      }))
    ),
  },
  resolveComments: {
    kind: "step",
    category: "create",
    view: lazy(() =>
      import("./resolve-comments").then(({ ResolveCommentsToolView }) => ({
        default: ResolveCommentsToolView,
      }))
    ),
  },
  getQueuedComments: {
    kind: "step",
    category: "create",
    view: lazy(() =>
      import("./get-queued-comments").then(({ GetQueuedCommentsToolView }) => ({
        default: GetQueuedCommentsToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
